<nav [ngClass]="{ 'container-fluid fm-global-navigation-sub-header': true }">
  <span
    [ngClass]="{ 'fm-global-navigation-sub-header--toggle': true, opened: !isCollapsed }"
  ></span>
  <ul [ngClass]="{ 'nav nav-pills': true }">
    <ng-container *ngFor="let m of menu; trackBy: trackByIdentity">
      <li
        class="dropdown nav-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: !m.list.length }"
        role="presentation"
      >
        <a *ngIf="!m.list.length" class="nav-link" [routerLink]="m.url" (mouseenter)="showTitle()"
          >{{ m.title }}
        </a>
        <span *ngIf="m.list.length" class="nav-link" (mouseenter)="showTitle()">{{ m.title }}</span>
        <ul *ngIf="m.list.length" class="dropdown-menu">
          <li
            *ngFor="let listItem of m.list; trackBy: trackByIdentity"
            [ngClass]="{ 'collapsed-list': hideMenu, 'expanded-list': !hideMenu }"
          >
            <a class="dropdown-item" [routerLink]="listItem.url" (click)="closeListMenu()">{{
              listItem.title
            }}</a>
          </li>
        </ul>
      </li>
    </ng-container>
  </ul>
</nav>
